import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'kui-side-panel-title',
    templateUrl: './side-panel-title.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KuiSidePanelTitleComponent { }
